var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashRed2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 5.00033V4.33366C13.8333 3.40024 13.8333 2.93353 13.6517 2.57701C13.4919 2.2634 13.2369 2.00844 12.9233 1.84865C12.5668 1.66699 12.1001 1.66699 11.1667 1.66699H9.83333C8.89991 1.66699 8.4332 1.66699 8.07668 1.84865C7.76308 2.00844 7.50811 2.2634 7.34832 2.57701C7.16667 2.93353 7.16667 3.40024 7.16667 4.33366V5.00033M8.83333 9.58366V13.7503M12.1667 9.58366V13.7503M3 5.00033H18M16.3333 5.00033V14.3337C16.3333 15.7338 16.3333 16.4339 16.0608 16.9686C15.8212 17.439 15.4387 17.8215 14.9683 18.0612C14.4335 18.3337 13.7335 18.3337 12.3333 18.3337H8.66667C7.26654 18.3337 6.56647 18.3337 6.03169 18.0612C5.56129 17.8215 5.17883 17.439 4.93915 16.9686C4.66667 16.4339 4.66667 15.7338 4.66667 14.3337V5.00033",
    stroke: "#ec3434",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed2);
export default __webpack_public_path__ + "static/media/trash-red-2.0f1a0cb0ec9b43e0941becf2b81b8512.svg";
export { ForwardRef as ReactComponent };